const CacheKeys = {
    "session" : "session"
}
export default CacheKeys